<div class="my-card-container d-flex flex-column">
  @if (allMyCards().length > 4) {
    <common-ui-components-search
      [mode]="'section'"
      [(searchText)]="searchText"
      placeHolder="جستجو در نام یا شماره کارت..."
    >
    </common-ui-components-search>
  }

  @if (initialized()) {
    @for (card of filteredMyCards(); track card) {
      <div class="mt-medium">
        <daily-bank-card-preview
          (click)="openCardSummary(card)"
          [config]="card()"
        ></daily-bank-card-preview>
      </div>
    } @empty {
      <div class="h-100 d-flex flex-column justify-content-center">
        <common-ui-components-no-item [title]="'در حال حاضر هیچ کارتی ثبت نشده است'"></common-ui-components-no-item>
      </div>
    }
  } @else {
    <div class="py-minus">
      <daily-bank-card-preview [config]="{ isLoading: true, isMinimized: true }"></daily-bank-card-preview>
    </div>
  }
</div>
<div
  class="button-box pt-plus pb-huge d-flex justify-content-end"
  [ngStyle]="bottonStyle()"
>
  <ngx-fab
    [icon]="{ name: 'plus' }"
    [routerLink]="['/profile', 'saved-cards', 'add', 'source']"
  >
    افزودن کارت
  </ngx-fab>
</div>
